package com.sddamico.draftmachine.util

import com.sddamico.draftmachine.data.ExternalProvider
import com.sddamico.draftmachine.data.Sport
import com.sddamico.draftmachine.models.FantraxLeagueOption

internal val ESPN_SUPPORTED_SPORTS = listOf(Sport.NFL, Sport.MLB, Sport.NBA, Sport.NHL)

private val FANTRAX_SUPPORTED_SPORTS = setOf(
  Sport.NFL,
  Sport.MLB,
  Sport.NBA,
  Sport.NHL,
  Sport.NCAA_FOOTBALL,
  Sport.NCAA_BASKETBALL,
  Sport.GOLF,
)

internal fun ExternalProvider.supports(sport: Sport): Boolean = when (this) {
  ExternalProvider.FANTRAX -> sport in FANTRAX_SUPPORTED_SPORTS
  ExternalProvider.ESPN -> sport in ESPN_SUPPORTED_SPORTS
}

internal fun compatibleProviders(requiredSport: Sport?): List<ExternalProvider> =
  ExternalProvider.entries.filter { requiredSport == null || it.supports(requiredSport) }

internal fun compatibleFantraxLeagues(
  leagues: List<FantraxLeagueOption>,
  requiredSport: Sport?,
): List<FantraxLeagueOption> =
  if (requiredSport == null) leagues else leagues.filter { it.sport == requiredSport }
